import React, { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { MainContext } from "../App";

const LoadingScreen = () => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const { gameScreenLoading, setGameScreenLoading, Theme } =
    useContext(MainContext);

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!!gameScreenLoading) {
      let startTime = Date.now();

      const interval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const newProgress = Math.min(
          100,
          Math.floor((elapsed / 3000) * 100 + Math.random() * 5)
        );
        setProgress(newProgress);

        if (elapsed >= 3000) {
          clearInterval(interval);
          setProgress(100);
          setTimeout(() => setGameScreenLoading(false), 3000); // short buffer
        }
      }, 150);

      return () => clearInterval(interval);
    }
  }, [gameScreenLoading]);

  const backgroundUrl = isMobile
    ? "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/loadingscreens%2Fmobile-loadingscreen.png?alt=media&token=4de14768-e0cd-42de-a065-f997b15d149c"
    : "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/loadingscreens%2Fweb-loadingscreen.png?alt=media&token=03a761fb-fea1-4c0d-95a5-9f3142e684b0";

  if (!gameScreenLoading) return null;

  return (
    <Box
      sx={{
        width: "100dvw",
        height: "100dvh",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000",
        position: "absolute",
        zIndex: 9999,
        top: 0,
        left: 0,
      }}
    >
      <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
        <img
          src={backgroundUrl}
          alt="Loading Background"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />

        {/* 🔵 Loading bar (bottom) */}
        <Typography
          variant="h4"
          sx={{
            position: "absolute",
            bottom: 45,
            left: "10%",
            fontWeight: 900,
            color: Theme.palette.text.main,
            textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.main}, 1px -1px 0 ${Theme.palette.tirciary.main}, -1px  1px 0 ${Theme.palette.tirciary.main}, 1px  3px 0 ${Theme.palette.tirciary.main}`,
          }}
        >
          LOADING...
        </Typography>
        <Box
          sx={{
            position: "absolute",
            bottom: 30,
            left: "10%",
            width: "80%",
            height: 12,
            backgroundColor: "#333",
            borderRadius: 6,
            overflow: "hidden",
            boxShadow: "0 0 8px rgba(0,0,0,0.7)",
            border: `3px solid ${Theme.palette.primary.main}`,
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: `${progress}%`,
              background: `linear-gradient(90deg,  ${Theme.palette.tirciary.main}, ${Theme.palette.secondary.main})`,
              transition: "width 0.2s ease-in-out",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LoadingScreen;
